import { FC } from 'react';
import { Paper, Modal, IconButton, Grid, TextField } from '@material-ui/core';
import { useStyles } from './styles';
import { useStore } from 'hooks/useRootStore';
import { AdditionalDataPopUpProps, LogsInfo, LogsInfoFormInput } from './types';
import { Controller, useForm } from 'react-hook-form';
import CloseIcon from '@material-ui/icons/Close';
import sampleProfile from '../../../assets/sample.svg';
import { getBaseUrl } from 'utils';
//import { capitalizeFirstLetter } from 'utils';

export const AdditionalDataPopUp: FC<AdditionalDataPopUpProps> = ({ open, handleClose }) => {
  const classes = useStyles();
  const organizationBlockMock1: LogsInfoFormInput<LogsInfo>[] = [
    { name: 'name', title: 'Name', placeholder: 'Name', required: true },
    { name: 'lastName', title: 'Last Name', placeholder: 'Last Name', required: true },
    { name: 'id', title: 'Id', placeholder: '1', required: true },
    { name: 'email', title: 'Email', placeholder: 'abc@xyz.com', required: true },
    { name: 'organizationName', title: 'Organization Name', placeholder: 'TestNew121', required: true },
    { name: 'organizationDomain', title: 'Organization Domain', placeholder: 'testnew121', required: true },
    {
      name: 'organizationFullDomain',
      title: 'Organization Full Domain',
      placeholder: 'testnew121l.com',
      required: true,
    },
    { name: 'eduNonProfitGovOrganization', title: 'eduNonProfitGovOrganization', placeholder: 'false', required: true },
    {
      name: 'salesTaxGstVatExemptOrganization',
      title: 'salesTaxGstVatExemptOrganization',
      placeholder: 'true',
      required: true,
    },
    { name: 'password', title: 'Password', placeholder: '12345678', required: true, disabled: true },
  ];
  const { control, reset } = useForm<LogsInfo>();
  const {
    logsTableStore: { logsInfo },
  } = useStore();
  const baseUrl = getBaseUrl().split('/', 3).join('/');

  return (
    <Modal className={classes.modal} disablePortal disableEnforceFocus disableAutoFocus open={open}>
      <Paper className={classes.paper} elevation={3}>
        <Grid className={classes.topBar} container justify='space-between' alignItems='center'>
          <div className={classes.title}>Details</div>
          <IconButton
            style={{ marginRight: -16 }}
            onClick={() => {
              handleClose();
              reset();
            }}>
            <CloseIcon />
          </IconButton>
        </Grid>
        <div className={classes.flexBox}>
          <div className={classes.profileContainer}>
            <img style={{width: '100%'}} src={ logsInfo?.imageUrl ? `${baseUrl}/${logsInfo.imageUrl}` : sampleProfile} alt='Profile' />{' '}
          </div>
          <form className={classes.formContainer}>
            <Grid container justify='space-between' className={classes.container}>
              <Grid className={classes.block} container>
                {organizationBlockMock1.map((item, index: number) => (
                  <Controller
                    key={index}
                    name={item.name}
                    defaultValue={logsInfo?.[item.name]}
                    control={control}
                    rules={{ required: item?.required }}
                    render={({ field, fieldState: { invalid } }) => (
                      <Grid container className={classes.row}>
                        <TextField
                          {...field}
                          label={item.title}
                          disabled={item.disabled}
                          error={invalid}
                          placeholder={item.placeholder}
                          helperText={invalid ? 'Required field' : ''}
                          className={classes.input}
                        />
                      </Grid>
                    )}
                  />
                ))}
              </Grid>
            </Grid>
          </form>
        </div>
      </Paper>
    </Modal>
  );
};
